import { render, staticRenderFns } from "./CreateTaskModal.vue?vue&type=template&id=239bf4e6&"
import script from "./CreateTaskModal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CreateTaskModal.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./CreateTaskModal.vue?vue&type=style&index=0&id=239bf4e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports